<template>
  <!-- add user modal -->
  <b-modal
    size="lg"
    centered
    hide-footer
    hide-header
    no-close-on-backdrop
    id="usermodal"
    :visible="openTagUsers"
    @hidden="closeTagUsers"
  >
    <div class="d-flex align-items-center justify-content-between">
      <div class="teams-modal-head">Tag User(s)</div>
      <div @click="closeTagUsers">
        <img
          src="../../../assets/New-imgs/teams-icons/teams-close-icon.svg"
          alt=""
          class="pointer rotate-on-hover"
        />
      </div>
    </div>
    <hr />
    <div class="teams-addUser-height">
      <div class="relativeclass w-100 teams-innerInputField">
        <img
          class="teams-setImage"
          src="../../../assets/img/search-bar-icon.svg"
          alt=""
        />

        <b-form-input
          placeholder="Search Users"
          @update="openModal"
          type="search"
          v-model.trim="username"
          debounce="500"
          class="search-input"
        >
        </b-form-input>
      </div>
      <hr />

      <div class="d-flex align-items-center justify-content-between">
        <div class="teams-modal-head">Users</div>
        <div class="teams-user-inner-container-head mr-3">
          Selected Users: {{ displayCount(allUsers.length) }}
        </div>
      </div>
      <b-overlay :show="tagUsersSpinner" rounded="sm">
        <div class="teams-addUser-container-height">
          <template v-if="fixedUsers.length > 0">
            <div
              class="
                d-flex
                align-items-center
                justify-content-between
                teams-addUser-container
                mt-2
                w-100
              "
              v-for="(user, index) in fixedUsers"
              :key="index"
            >
              <div class="d-flex align-items-center" style="width: 80%">
                <div class="text-center newtp-checkbox" style="width: 10%">
                  <b-form-checkbox
                    v-model="allUsers"
                    :value="user"
                    @change="deselect"
                  >
                  </b-form-checkbox>
                </div>
                <div style="width: 90%">
                  <div class="teams-addUser-container-head text-truncate w-100">
                    {{ user.username }}
                  </div>
                  <div
                    class="teams-addUser-container-subhead w-100 text-truncate"
                  >
                    {{ user.email }}
                  </div>
                </div>
              </div>
              <div
                class="teams-addUser-container-rightContent d-flex"
                v-b-tooltip.hover="user.roleName"
              >
                <div
                  v-if="user.roles.length > 0"
                  class="text-truncate"
                  style="min-width: auto; max-width: 100px"
                >
                  {{ user.roles[0] }}
                </div>
                <template v-if="user.roles.length > 1">
                  <div
                    v-if="user.roles.length === 1"
                    class="text-truncate"
                    style="min-width: auto; max-width: 100px"
                  >
                    {{ user.roles[0] }}
                  </div>
                  <div
                    v-else
                    class="text-truncate"
                    style="min-width: auto; max-width: 100px"
                  >
                    <span
                      v-for="(role, index) in user.roles.slice(1, 2)"
                      :key="index"
                    >
                      + {{ role }}
                    </span>
                    <span v-if="user.roles.length > 2"> + ...</span>
                  </div>
                </template>
              </div>
            </div>
          </template>
          <template v-else-if="!tagUsersSpinner">
            <div
              class="
                d-flex
                align-items-center
                justify-content-center
                h-100
                w-100
                flex-column
              "
            >
              <div>
                <img
                  src="../../../assets/New-imgs/teams-icons/teams-adduser-empty-img.svg"
                  alt=""
                />
              </div>
              <div
                class="mt-2 teams-empty-container-font"
                v-if="fixedUsers.length == 0 && username !== ''"
              >
                No matching results for "{{ username }}"
              </div>
              <div
                class="mt-2 teams-empty-container-font"
                v-if="fixedUsers.length == 0 && username == ''"
              >
                No Users found
              </div>
            </div>
          </template>
        </div>
      </b-overlay>
    </div>
    <hr />

    <div class="d-flex align-items-center justify-content-end">
      <b-button class="new-whiteBtn mr-3" @click="closeTagUsers"
        >Cancel</b-button
      >
      <b-button
        class="new-blueBtn"
        @click="addUsers"
        :disabled="this.selectedName.length == 0 && this.allUsers.length == 0"
        >Add Users</b-button
      >
    </div>
  </b-modal>
</template>
<script>
import { mapGetters } from "vuex";
import { getUsers, addFolderUser } from "../../../utils/apiFunctions";
import toast from "../../../components/mixin/toast";

export default {
  data() {
    return {
      // BOOLEAN
      selectAllUsers: false,
      tagUsersSpinner: false,
      // ARRAYS
      allUsers: [],
      selectedName: [],
      selectedID: [],
      fixedUsers: [],
      // STRINGS
      username: "",
    };
  },

  props: {
    openTagUsers: Boolean,
  },

  mixins: [toast],

  computed: {
    ...mapGetters("userVUEX", {
      getlicenseKey: "getlicenseKey",
    }),
    ...mapGetters("teamsVUEX", {
      getActive: "getActive",
    }),
  },

  watch: {
    openTagUsers(newQ, oldQ) {
      if (newQ !== oldQ && newQ) {
        this.openModal();
      }
    },
  },

  methods: {
    displayCount(data) {
      if (data < 9) {
        return "0" + data;
      } else {
        return data;
      }
    },
    closeTagUsers() {
      this.clearUsers();
      this.$emit("close-tag-users");
    },
    deselect() {
      if (this.allUsers.length != this.fixedUsers.length) {
        this.selectAllUsers = false;
      } else {
        this.selectAllUsers = true;
      }
    },
    // OPEN TAG USER MODEL AND GET ALL USER DATA
    async openModal() {
      try {
        this.tagUsersSpinner = true;
        let payload = {
          licenseKey: this.getlicenseKey,
          folderID: this.getActive,
          project: "recruitment",
          searchQuery: this.username,
        };
        const response = await getUsers(payload);
        this.fixedUsers = response.data.data;
        // Loop through the fixedUsers array
        this.fixedUsers.forEach((user) => {
          if (user.isSelected) {
            // If the user is selected, push it into the allUsers array
            this.allUsers.push(user);
          }
        });
      } catch (error) {
        this.errorModal("Something went wrong");
      } finally {
        this.tagUsersSpinner = false;
      }
    },
    //ADD USER
    async addUsers() {
      try {
        let userslist = [];
        this.selectedName.forEach((user) => {
          userslist.push(user);
          this.selectedID.push(user.userID);
        });
        this.allUsers.forEach((user) => {
          if (!this.selectedID.includes(user.userID)) {
            this.selectedID.push(user.userID);
          }
          if (!userslist.some((u) => u.userID === user.userID)) {
            userslist.push(user);
          }
        });
        let payload = {
          licenseKey: this.getlicenseKey,
          folderID: this.getActive,
          project: "recruitment",
          action: "user",
          users: this.selectedID,
        };
        const response = await addFolderUser(payload);
        if (response.status == 200) {
          this.$store.commit("teamsVUEX/setUserAdded");
          if (userslist.length === 1) {
            this.successModal("User added successfully");
          } else {
            this.successModal("Users added successfully");
          }
          this.clearUsers();
          this.$emit("close-tag-users");
        } else {
          this.errorModal(response.data.data.Detail);
        }
      } catch (error) {
        console.error(error);
      }
    },
    // REMOVE ALL SELECTED USERS DATA
    clearUsers() {
      this.selectAllUsers = false;
      this.allUsers = [];
      this.selectedID = [];
      this.selectedName = [];
      this.username = "";
    },
  },
};
</script>
